import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { colorGray } from 'styles/layout/colors';
const IconHouzz = t0 => {
  const $ = _c(7);
  const {
    color: t1,
    width: t2,
    height: t3,
    className: t4
  } = t0;
  const color = t1 === undefined ? colorGray : t1;
  const width = t2 === undefined ? "15" : t2;
  const height = t3 === undefined ? "24" : t3;
  const className = t4 === undefined ? "" : t4;
  let t5;
  if ($[0] !== color) {
    t5 = <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd"><g><polygon fill={color} points="14.8018 12 14.8018 20 7.8708 24 7.8708 15.998 0.9418 20 0.9418 3.998 7.8708 0 7.8708 8 0.9438 12 7.8708 15.998 7.8708 8 14.8018 3.998" /></g></g>;
    $[0] = color;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  let t6;
  if ($[2] !== className || $[3] !== height || $[4] !== t5 || $[5] !== width) {
    t6 = <svg width={width} height={height} viewBox="0 0 15 24" className={className}>{t5}</svg>;
    $[2] = className;
    $[3] = height;
    $[4] = t5;
    $[5] = width;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
};
IconHouzz.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
export default IconHouzz;